var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.577 8.53a3.765 3.765 0 100-7.53 3.765 3.765 0 000 7.53z",
    stroke: "url(#person_svg__a)",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.342 10.036h.265a2.26 2.26 0 012.24 1.979l.295 2.352a1.506 1.506 0 01-1.495 1.692H2.507a1.506 1.506 0 01-1.495-1.692l.293-2.353a2.26 2.26 0 012.243-1.978h.264",
    stroke: "url(#person_svg__b)",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "person_svg__a",
    x1: 10.978,
    y1: 1.144,
    x2: 9.414,
    y2: 9.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4888E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1658BA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTcuNTc2ODIgOC41Mjk4YzIuMDc5MyAwIDMuNzY0ODgtMS42ODU2IDMuNzY0ODgtMy43NjQ5UzkuNjU2MTIgMSA3LjU3NjgyIDFzLTMuNzY0OSAxLjY4NTYtMy43NjQ5IDMuNzY0OSAxLjY4NTYgMy43NjQ5IDMuNzY0OSAzLjc2NDlaIiBzdHJva2U9InVybCgjYSkiIHN0cm9rZS13aWR0aD0iMS43NSIvPgogIDxwYXRoIGQ9Ik0xMS4zNDE4IDEwLjAzNTZoLjI2NWMuNTUwNS4wMDAyIDEuMDgyLjIwMTQgMS40OTQ2LjU2NTcuNDEyNi4zNjQ0LjY3OC44NjY5Ljc0NjMgMS40MTMybC4yOTQ0IDIuMzUyM2MuMDI2NS4yMTE5LjAwNzYuNDI3LS4wNTU0LjYzMTEtLjA2My4yMDQtLjE2ODcuMzkyMy0uMzEwMS41NTI0LS4xNDEzLjE2MDEtLjMxNTEuMjg4My0uNTA5OC4zNzYxLS4xOTQ3LjA4NzgtLjQwNTguMTMzMS0uNjE5NC4xMzMxSDIuNTA2MjljLS4yMTM1NiAwLS40MjQ2OS0uMDQ1My0uNjE5MzctLjEzMzEtLjE5NDY4LS4wODc4LS4zNjg0Ny0uMjE2LS41MDk4Mi0uMzc2MS0uMTQxMzUtLjE2MDEtLjI0NzA0LS4zNDg0LS4zMTAwNS0uNTUyNC0uMDYzMDItLjIwNDEtLjA4MTkwOS0uNDE5Mi0uMDU1NDMtLjYzMTFsLjI5MzY3LTIuMzUyM2MuMDY4MjktLjU0NjUuMzMzODgtMS4wNDkyLjc0NjgyLTEuNDEzNy40MTI5NS0uMzY0NC45NDQ4LS41NjU0IDEuNDk1NTUtLjU2NTJoLjI2NDMiIHN0cm9rZT0idXJsKCNiKSIgc3Ryb2tlLXdpZHRoPSIxLjc1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0iYSIgeDE9IjEwLjk3OCIgeTE9IjEuMTQzNzMiIHgyPSI5LjQxMzgzIiB5Mj0iOS4wODAwNCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjNDg4OEU4Ii8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzE2NThCQSIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+Cjwvc3ZnPg==";
export { ForwardRef as ReactComponent };